import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from "react";
import './styles.css';
import './App.css';
import NavBar from './component/NavBar.js';
import Home from './page/Home.js';
// import Work from './page/MyWork.js'; // Disabled - Work link now anchors to case studies
import ProjectTemplate from './page/ProjectTemplate.js';
import Fempaq from './page/fempaq.js';
import ProAdmin from './page/ProAdmin.js';
import TysonCaseStudy from './page/TysonCaseStudy.js';
import FempaqCaseStudy from './page/FempaqCaseStudy.js';
import Contact from './component/Contact.js';
import Footer from './component/Footer.js';

const ScrollToTop = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return children;
};

function App() {
  return (
    <BrowserRouter>
      <NavBar />

      <ScrollToTop>

        <Routes> 
          <Route path="/" element={<Home />} />
          {/* <Route path="/work" element={<Work />} /> */}
          <Route path="/post/:id" element={<ProjectTemplate />} />
          <Route path="/fempaq" element={<Fempaq />} />
          <Route path="/ProAdmin" element={<ProAdmin />} />
          <Route path="/tyson" element={<TysonCaseStudy />} />
          <Route path="/fempaq-case-study" element={<FempaqCaseStudy />} />
        </Routes>
        <Contact />
        <Footer />

      </ScrollToTop>

    </BrowserRouter>
  );
}

export default App;
